import { render, staticRenderFns } from "./chatBanList.vue?vue&type=template&id=68836d1a&scoped=true"
import script from "./chatBanList.vue?vue&type=script&lang=ts"
export * from "./chatBanList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68836d1a",
  null
  
)

export default component.exports